import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function PermitMenu(props) {
  return (
    <Dropdown
      menuKey="permit"
      menu={projectMenus.permit}
      {...props}
    />
  );
}
